import { render, staticRenderFns } from "./DepartmentUserRow.vue?vue&type=template&id=4dbcc7c0&scoped=true"
import script from "./DepartmentUserRow.vue?vue&type=script&lang=js"
export * from "./DepartmentUserRow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUserRow.vue?vue&type=style&index=0&id=4dbcc7c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbcc7c0",
  null
  
)

export default component.exports